{
  "panel": {
    "title": "الملاحظات",
    "newNote_title": "ملاحظة جديدة",
    "search_placeholder": "ابحث في الملاحظات…",
    "search_aria": "البحث في الملاحظات",
    "clearSearch_aria": "مسح البحث",
    "editorPlaceholder": "بمَ تفكّر…",
    "titleInput_placeholder": "بلا عنوان",
    "untitled": "بلا عنوان",
    "emptyNote": "ملاحظة فارغة",
    "loadingNotes": "جارٍ تحميل الملاحظات…",
    "noNotesYet": "لا توجد ملاحظات بعد. اضغط + لإنشاء واحدة.",
    "noResults": "لا توجد نتائج لـ \"{{query}}\"",
    "noNotesTagged": "لا توجد ملاحظات موسومة بـ {{tag}}",
    "tagFilterAll": "الكل",
    "filterByTag_aria": "التصفية حسب الوسم",
    "templates": "القوالب",
    "editorTheme_aria": "سمة المحرّر",
    "themeActive_aria": "سمة {{theme}} (نشطة)",
    "theme_aria": "سمة {{theme}}",
    "themeName": {
      "dark": "داكن",
      "sepia": "بنّي داكن",
      "light": "فاتح",
      "forest": "غابة"
    },
    "voice": "صوت",
    "voice_title": "ملاحظة صوتية",
    "voiceUnavailable_title": "تحويل الكلام غير متاح في هذا المتصفح",
    "openVoiceRecorder_aria": "فتح مسجّل الملاحظات الصوتية",
    "summarizing_title": "جارٍ التلخيص…",
    "summarize_title": "تلخيص",
    "summarizeNote_aria": "تلخيص الملاحظة",
    "aiCommands_title": "أوامر الذكاء الاصطناعي  Cmd+K",
    "openAiPalette_aria": "فتح لوحة أوامر الذكاء الاصطناعي",
    "enterFocusMode_title": "وضع التركيز  Cmd+Shift+F",
    "exitFocusMode_title": "الخروج من وضع التركيز  Cmd+Shift+F",
    "enterFocusMode_aria": "الدخول إلى وضع التركيز",
    "exitFocusMode_aria": "الخروج من وضع التركيز",
    "export_title": "تصدير الملاحظة",
    "delete_title": "حذف الملاحظة",
    "delete_aria": "حذف الملاحظة",
    "moreActions_title": "المزيد من الإجراءات",
    "wordCount_zero": "{{formatted}} كلمة · ~{{minutes}} دقيقة قراءة",
    "wordCount_one": "{{formatted}} كلمة · ~{{minutes}} دقيقة قراءة",
    "wordCount_two": "{{formatted}} كلمتان · ~{{minutes}} دقيقة قراءة",
    "wordCount_few": "{{formatted}} كلمات · ~{{minutes}} دقيقة قراءة",
    "wordCount_many": "{{formatted}} كلمة · ~{{minutes}} دقيقة قراءة",
    "wordCount_other": "{{formatted}} كلمة · ~{{minutes}} دقيقة قراءة",
    "referencedBy_zero": "مُشار إليها بواسطة {{count}}",
    "referencedBy_one": "مُشار إليها بواسطة {{count}}",
    "referencedBy_two": "مُشار إليها بواسطة {{count}}",
    "referencedBy_few": "مُشار إليها بواسطة {{count}}",
    "referencedBy_many": "مُشار إليها بواسطة {{count}}",
    "referencedBy_other": "مُشار إليها بواسطة {{count}}",
    "noMatchingNotes": "لا توجد ملاحظات مطابقة",
    "mobileTabs_aria": "عرض الملاحظات",
    "mobileTabNotes": "الملاحظات",
    "mobileTabEditor": "المحرّر",
    "saveFailed": "تعذّر حفظ الملاحظة: {{message}}",
    "deleteFailed": "تعذّر حذف الملاحظة",
    "loadFailed": "تعذّر تحميل الملاحظات",
    "analyzeFailed": "تعذّر تحليل الملاحظة",
    "aiCommandFailed": "فشل أمر الذكاء الاصطناعي",
    "unknownError": "خطأ غير معروف"
  },
  "paywall": {
    "title": "الملاحظات جزء من Rhemn Pro",
    "safariBody": "افتح الملاحظات المتزامنة والإملاء وملخصات الذكاء الاصطناعي مع Rhemn Pro. عضو بالفعل؟ يُفتح تلقائيًا عند تسجيل الدخول.",
    "body": "افتح ملاحظات مُزامَنة، وإملاءً عبر المتصفح، وملخّصات ذكاء اصطناعي مُنظَّمة."
  },
  "format": {
    "bold": "غامق",
    "italic": "مائل",
    "strikethrough": "يتوسطه خط",
    "inlineCode": "كود مضمّن",
    "heading1": "عنوان 1",
    "heading2": "عنوان 2",
    "heading3": "عنوان 3",
    "bulletList": "قائمة نقطية",
    "numberedList": "قائمة مرقّمة",
    "blockquote": "اقتباس",
    "codeBlock": "كتلة كود",
    "toggleBold_aria": "تبديل الغامق",
    "toggleItalic_aria": "تبديل المائل",
    "toggleStrikethrough_aria": "تبديل الخط في المنتصف",
    "toggleInlineCode_aria": "تبديل الكود المضمّن",
    "toggleBulletList_aria": "تبديل القائمة النقطية",
    "toggleNumberedList_aria": "تبديل القائمة المرقّمة",
    "toggleBlockquote_aria": "تبديل الاقتباس",
    "formatOptions_aria": "خيارات التنسيق"
  },
  "analysis": {
    "heading": "ملخّص",
    "onDevice": "⚡ على الجهاز",
    "onDevice_aria": "تمت المعالجة على الجهاز",
    "applyToNote_title": "تطبيق على الملاحظة",
    "applyToNote_aria": "تطبيق الملخّص على الملاحظة",
    "summaryLabel": "ملخّص",
    "keyPointsLabel": "النقاط الرئيسية",
    "noKeyPoints": "لم تُرجَع نقاط رئيسية لهذه الملاحظة."
  },
  "export": {
    "markdown": "تصدير بصيغة Markdown",
    "plainText": "تصدير كنص عادي",
    "pdf": "تصدير بصيغة PDF",
    "allZip": "تصدير الكل كملف ZIP",
    "label": "تصدير"
  },
  "cmdk": {
    "dialog_aria": "لوحة أوامر الذكاء الاصطناعي",
    "input_placeholder": "اسأل الذكاء الاصطناعي أو نفّذ أمرًا…",
    "esc": "Esc",
    "back_aria": "رجوع",
    "translateTo": "ترجمة إلى",
    "language_placeholder": "اللغة…",
    "aiActions": "إجراءات الذكاء الاصطناعي",
    "noCommandsMatch": "لا توجد أوامر تطابق \"{{query}}\"",
    "continue": {
      "label": "متابعة الكتابة",
      "description": "تابع من حيث توقّفت"
    },
    "summarize": {
      "label": "تلخيص التحديد",
      "description": "اختصِر إلى نقاط رئيسية"
    },
    "formal": {
      "label": "اجعله رسميًا",
      "description": "ارفع النبرة إلى مستوى احترافي"
    },
    "simplify": {
      "label": "تبسيط",
      "description": "لغة أقصر وأوضح"
    },
    "translate": {
      "label": "ترجمة إلى…",
      "description": "ترجِم إلى لغة أخرى"
    },
    "expand": {
      "label": "توسيع هذه النقطة",
      "description": "حوّل النقطة المحدّدة إلى نص"
    },
    "languages": {
      "Spanish": "الإسبانية",
      "Arabic": "العربية",
      "French": "الفرنسية",
      "German": "الألمانية",
      "Japanese": "اليابانية",
      "Portuguese": "البرتغالية"
    }
  },
  "templates": {
    "dialog_aria": "اختيار قالب",
    "header": "اختر قالبًا",
    "builtInLabel": "مدمج",
    "myTemplatesLabel": "قوالبي",
    "saveCurrent": "حفظ الملاحظة الحالية كقالب",
    "myTemplatesEmpty": "ستظهر قوالبك المحفوظة هنا",
    "useTemplate": "استخدام القالب",
    "meeting": {
      "name": "ملاحظات الاجتماع",
      "description": "تدوين القرارات وبنود العمل",
      "structure": "الحضور / جدول الأعمال / الملاحظات / الإجراءات"
    },
    "journal": {
      "name": "يوميات",
      "description": "تأمّل في يومك",
      "structure": "الامتنان / إنجازات اليوم / الملاحظات"
    },
    "book": {
      "name": "ملخّص كتاب",
      "description": "تدوين الأفكار الرئيسية من كتاب",
      "structure": "الفكرة الأساسية / اقتباسات رئيسية / الدروس المستفادة"
    },
    "project": {
      "name": "موجز مشروع",
      "description": "حدّد النطاق والأهداف وأصحاب المصلحة",
      "structure": "الهدف / النطاق / المخاطر / الجدول الزمني"
    },
    "brainstorm": {
      "name": "عصف ذهني",
      "description": "تدوين الأفكار بحرّية",
      "structure": "الموضوع / الأفكار / الخطوات التالية"
    },
    "weekly": {
      "name": "مراجعة أسبوعية",
      "description": "راجِع أسبوعك وخطّط له",
      "structure": "الإنجازات / التحدّيات / مجالات التركيز"
    }
  },
  "voice": {
    "dialog_aria": "مسجّل الملاحظات الصوتية",
    "cancel_aria": "إلغاء",
    "statusRecording": "جارٍ التسجيل",
    "statusTranscribing": "جارٍ التفريغ…",
    "statusReview": "مراجعة",
    "skip": "تخطّي",
    "mark": "علامة",
    "mark_title": "أضف علامة زمنية",
    "captureMeeting": "التقاط اجتماع",
    "captureMeeting_title": "التقط أيضًا الصوت من علامة تبويب اجتماع",
    "meeting": "اجتماع",
    "meeting_title": "جارٍ التقاط علامة تبويب الاجتماع",
    "markers_aria": "العلامات الزمنية",
    "listening": "جارٍ الاستماع…",
    "micDenied": "الوصول إلى الميكروفون غير مفعّل. اسمح به من الإعدادات ثم حاول مرة أخرى.",
    "captureFailed": "تعذّر بدء التسجيل. حاول مرة أخرى بعد قليل.",
    "tabPicker_aria": "اختر علامة تبويب اجتماع لالتقاطها",
    "captureFrom": "التقاط الصوت من…",
    "noAudibleTab": "لا توجد علامة تبويب تشغّل صوتًا. افتح اجتماعك وتأكّد من أن أحدًا يتحدّث، ثم حاول مجددًا.",
    "tabPickerCancel": "إلغاء",
    "tabTranscript": "النص المُفرَّغ",
    "structuring": "جارٍ التنظيم…",
    "structuredNote": "ملاحظة مُنظَّمة",
    "structureFailed": "تعذّر إنشاء الملاحظة المنظّمة.",
    "retryStructure": "حاول مرة أخرى",
    "browserTranscript": "نص المتصفح المُفرَّغ",
    "nothingCaptured": "لم يُلتقَط شيء.",
    "buildingStructured": "جارٍ بناء ملاحظة مُنظَّمة…",
    "cancel": "إلغاء",
    "stop": "إيقاف",
    "recordAgain": "تسجيل مجددًا",
    "saveToNote": "حفظ في ملاحظة",
    "statusMeeting": "اجتماع",
    "captureStrip_aria": "جارٍ التقاط الصوت من {{tab}}",
    "stopCapture": "إيقاف الالتقاط",
    "stopCapture_title": "أوقف التقاط علامة التبويب — يستمر الميكروفون في التسجيل",
    "stopsIn": "يتوقف خلال {{time}}",
    "autoStopped": "توقف التسجيل عند حد الستين دقيقة.",
    "autoStoppedQuota": "توقف التسجيل — لقد استخدمت دقائق النسخ لهذا الشهر.",
    "captureLost": "أُغلقت علامة تبويب الاجتماع. ما زال الميكروفون يسجّل.",
    "tabSummary": "الملخص",
    "noSpeakers": "لم يتم التعرف على المتحدثين",
    "speakerN": "المتحدث {{number}}",
    "renameSpeaker_aria": "إعادة تسمية {{name}} — ينطبق على كل أسطره",
    "renameSpeaker_input_aria": "اسم المتحدث",
    "turnTime_title": "قيل في {{time}}",
    "actionItemsTitle": "بنود العمل",
    "actionsCount": "{{checked}} من {{total}}",
    "addToTasks_zero": "أضف إلى المهام",
    "addToTasks_one": "أضف {{count}} إلى المهام",
    "addToTasks_two": "أضف {{count}} إلى المهام",
    "addToTasks_few": "أضف {{count}} إلى المهام",
    "addToTasks_many": "أضف {{count}} إلى المهام",
    "addToTasks_other": "أضف {{count}} إلى المهام",
    "addToTasksZero": "أضف إلى المهام",
    "adding": "جارٍ الإضافة…",
    "tasksAdded_zero": "لم تُضف مهام",
    "tasksAdded_one": "تمت إضافة مهمة واحدة",
    "tasksAdded_two": "تمت إضافة مهمتين",
    "tasksAdded_few": "تمت إضافة {{count}} مهام",
    "tasksAdded_many": "تمت إضافة {{count}} مهمة",
    "tasksAdded_other": "تمت إضافة {{count}} مهمة",
    "viewTasks": "عرض",
    "addFailed": "تعذّرت الإضافة — حاول مرة أخرى.",
    "minutesLeft_zero": "لا دقائق متبقية",
    "minutesLeft_one": "دقيقة واحدة متبقية",
    "minutesLeft_two": "دقيقتان متبقيتان",
    "minutesLeft_few": "{{count}} دقائق متبقية",
    "minutesLeft_many": "{{count}} دقيقة متبقية",
    "minutesLeft_other": "{{count}} دقيقة متبقية",
    "minutesLeftShort_zero": "لا دقائق متبقية",
    "minutesLeftShort_one": "دقيقة واحدة متبقية",
    "minutesLeftShort_two": "دقيقتان متبقيتان",
    "minutesLeftShort_few": "{{count}} دقائق متبقية",
    "minutesLeftShort_many": "{{count}} دقيقة متبقية",
    "minutesLeftShort_other": "{{count}} دقيقة متبقية",
    "minutesLeft_title": "{{count}} دقيقة نسخ متبقية هذا الشهر",
    "quotaExhausted": "لقد استخدمت دقائق الاجتماعات لهذا الشهر. تتجدد في {{date}}.",
    "quotaUnknown": "الدقائق المتبقية غير معروفة — قد يبلغ التسجيل حدك الشهري",
    "meetingProRequired": "نسخ الاجتماعات جزء من Pro. نصّك المباشر محفوظ أدناه.",
    "gateTitle": "تسجيل الاجتماعات",
    "gateBody": "سجّل علامة تبويب اجتماع مع الميكروفون — مع التعرف على المتحدثين واستخراج بنود العمل. متضمَّن مع Pro.",
    "gateLater": "ليس الآن",
    "gateCta": "اطّلع على Pro",
    "roomOption": "بدون علامة تبويب — سجّل الغرفة",
    "roomHint": "مكالمة على مكبّر الصوت، أو تطبيق مستقل، أو أشخاص في الغرفة — أي شيء يمكنك سماعه بصوت مسموع.",
    "roomHint_title": "إذا كان الطرف الآخر في سماعات رأسك، فلن يسمعه الميكروفون — استخدم مكبّر الصوت.",
    "recordRoom": "سجّل الغرفة",
    "recordRoom_title": "سجّل كل من يسمعه الميكروفون — مع التعرف على المتحدثين",
    "roomStart": "ابدأ",
    "statusRoom": "الغرفة",
    "roomStrip": "جارٍ تسجيل الغرفة",
    "roomStrip_aria": "جارٍ تسجيل الغرفة — كل من يسمعه الميكروفون",
    "roomOff": "إيقاف",
    "roomOff_title": "أوقف وضع الغرفة — تصبح هذه ملاحظة صوتية عادية",
    "roomRenameHint": "انقر على اسم لإعادة تسميته — أحد هؤلاء هو أنت.",
    "gateBodyRoom": "سجّل ما يُقال من حولك — مع التعرف على المتحدثين واستخراج بنود العمل. متضمَّن مع Pro.",
    "roomHintDevice": "لا يمكن تسجيل المكالمات الجارية على هذا الجهاز — نظام iOS يُبقيها خاصة. أما هاتف آخر على مكبّر الصوت، أو محادثة في الغرفة، فيمكن تسجيلهما.",
    "autoStoppedSize": "توقف التسجيل عند حد حجم الرفع.",
    "tooLarge": "كان التسجيل أكبر من أن يُرفع، لذا تعذّر نسخه.",
    "destTo": "إلى",
    "dest_aria": "الإضافة إلى القائمة: {{name}}",
    "destMenu_aria": "اختر قائمة",
    "destNewPending_aria": "قائمة جديدة: {{name}}"
  },
  "meetingNotice": {
    "title": "اجتماعاتك، في ملاحظاتك",
    "body": "يمكن لـ Rhemn الآن تسجيل علامة تبويب اجتماع تختارها — فقط أثناء تسجيل ملاحظة صوتية، وفقط علامة التبويب التي تحددها.",
    "factPrivacy": "تتم معالجة الصوت لإنشاء النص ثم يُحذف. لا تُخزَّن التسجيلات أبدًا.",
    "factControl": "لا يُلتقط أي شيء حتى تضغط على التسجيل وتختار علامة تبويب.",
    "cta": "فهمت",
    "privacyLink": "اقرأ سياسة الخصوصية",
    "dialog_aria": "حول إذن تسجيل الاجتماعات الجديد"
  }
}
